const readmoreSelector = ".read-more";
const readlessSelector = ".read-less";
const readmoreButtonSelector = ".read-collapse-toggle";
const summarySelector = ".summary";
const showMoreClass = "summary-truncate";

export function attachReadMoreClick(){
    $(readmoreButtonSelector).click(function(event){
        $(summarySelector).toggleClass(showMoreClass)
        $(readmoreSelector).toggleClass('d-none')
        $(readlessSelector).toggleClass('d-none')
    })
}
